/*
* @desc 头部布局
* @author caoyx
*/
import styles from './header.scss';
import React, { PureComponent } from 'react';
import { Popconfirm } from 'antd';
import classNames from 'classnames';
import { Link, hashHistory } from 'react-router';
import { clear, getLocal } from '../../utils/storage';
import { CURRENT_USER_INFO } from '../../constants/common';
import csrcLogoJPG from '../../images/csrcLogo.jpg';
import { logout } from '../../services/login';

/**
 * @desc 页面顶部组件
 */
export default class Header extends PureComponent {
    constructor(props) {
        super(props);
        this.userInfo = getLocal(CURRENT_USER_INFO) || {};
    }

    /**
     * @desc 登出
     */
    handleLogout = () => {
        logout().then(() => {
            clear(); // 清缓存
            hashHistory.replace('/login');
        });
    };

    render() {

        return (
            <div className={styles.header}>
                <div className={styles.middleBox}>
                    <div className={styles.logo}>
                        <img src={csrcLogoJPG} />
                    </div>
                    <ul className={styles.menuList}>
                        <li>
                            <Link to="/jgtj" activeClassName={styles.navAction}>
                                监管统计
                            </Link>
                        </li>
                        {/* <li>
                            <Link to="/bgcx" activeClassName={styles.navAction}>
                                报告查询
                            </Link>
                        </li> */}
                        <li>
                            <Link to="/cwhx" activeClassName={styles.navAction}>
                                财务画像
                            </Link>
                        </li>
                        <li>
                            <Link to="/grzx" activeClassName={styles.navAction}>
                                个人中心
                            </Link>
                        </li>
                    </ul>
                    <div className={styles.account}>
                        <span className={styles.userName}>{this.userInfo.userName}</span>
                        <Popconfirm
                            title="确定要退出登录吗?"
                            onConfirm={this.handleLogout}
                            okText="是"
                            cancelText="否"
                            placement="bottom"
                        >
                            <i className={classNames(styles.iconDengChu, 'iconfont', 'icon-dengchu')} />
                        </Popconfirm>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/header/Header.jsx